import React, { useEffect } from "react";
import { Separator } from "../../ui/separator";

const ChildPrivacy  = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="flex-grow bg-white py-8 md:py-12">
      <div className="container mx-auto px-2 md:px-4">
        <div className="max-w-4xl mx-auto">
          {/* Page Header */}
          <div className="mb-8 md:mb-12 mt-16">
            <h1 className="text-3xl font-bold mb-6 text-center text-[#523880]">
              Age Restriction & Child Safety Policy
            </h1>
            <p className="text-sm text-gray-500 text-center mb-8">
              Last updated: Feb 16, 2026
            </p>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <p className="text-base leading-relaxed text-gray-800 mb-4">
              Oye Creators, operated by TTL Media Private Limited (“Company”, “we”, “our”, “Platform”), is strictly intended for individuals aged 18 years and above.
We are committed to maintaining a safe and compliant environment in accordance with Google Play Developer Program Policies and applicable laws.
            </p>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mt-8 mb-4 text-[#EE3788]">
                1. Age Restriction
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                The Platform is available only to individuals who are at least 18 years old.
                We do not knowingly permit individuals under the age of 18 to:
              </p>
              <ul className="list-disc ml-6 space-y-2">
                <li className="text-base leading-relaxed text-gray-800">
                  Register an account
                </li>
                <li className="text-base leading-relaxed text-gray-800">
                  Access the Platform
                </li>
                 <li className="text-base leading-relaxed text-gray-800">
                  Participate in campaigns
                </li>
                 <li className="text-base leading-relaxed text-gray-800">
                  Use any services provided by Oye Creators
                </li>
              </ul>
            </section>
            <p className="text-base leading-relaxed text-gray-800 mb-4">
                If we discover that a user is under 18 years of age, the account will be immediately suspended or permanently deleted.
            </p>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                2. Age Verification
              </h2>
              <p className="text-base leading-relaxed text-gray-800 mb-4">
                To enforce this policy:
              </p>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>
                  Users may be required to confirm they are 18 years or older before accessing the Platform.
                </li>
                <li>
                  Date of Birth (DOB) may be collected during registration for age verification.
                </li>
                <li>
                  Accounts found to contain false age information may be terminated.
                </li>
              </ul>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                3. No Collection of Children's Data
              </h2>
              <p className="mb-3">
                We do not knowingly collect, store, or process personal information from individuals under the age of 18.
                If we become aware that personal data of a minor has been collected:
              </p>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>
                  The account will be removed.
                </li>
                <li>
                  The associated data will be deleted promptly.
                </li>
                <li>
                  Appropriate action will be taken to prevent recurrence.
                </li>
              </ul>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                4. Reporting Concerns
              </h2>
              <p className="mb-3">
                If you believe that a minor has accessed or registered on the Platform, please contact us immediately:
              </p>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>
                  <strong>Email:</strong> privacy@oyecreators.com
                </li>
                <li>
                  <strong>Subject:</strong> Minor Access Report
                </li>
              </ul>
              <p className="mb-3">
                We will investigate and take appropriate action.             
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                5. Compliance & Enforcement
              </h2>
              <p className="mb-3">
               Oye Creators maintains internal safeguards to ensure compliance with:
              </p>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>
                  Google Play Developer Program Policies
                </li>
                <li>
                  Applicable data protection regulations
                </li>
                <li>
                  Child protection standards
                </li>
              </ul>
              <p className="mb-3">
               Any attempt to misrepresent age or bypass safeguards may result in permanent account termination.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                6. Policy Updates
              </h2>
              <p className="mb-3">
               We may update this policy from time to time. Continued use of the Platform constitutes acceptance of any updates.
              </p>
            </section>

            <Separator className="my-8 bg-gray-200" />

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-[#EE3788]">
                Contact Information
              </h2>
              <p className="mb-3">
                TTL Media Private Limited <br/>Quantum Works, CTS No. 177 p,<br/>S. No. 43/2, near Nal stop,<br/>Pandurang Colony, Erandwane,<br/>Pune, Maharashtra 411004<br/>Email: privacy@oyecreators.com<br/>Phone: +91-8484834105
              </p>
            </section>
          </div>
        </div>
      </div>
    </main>
  )
}

export default ChildPrivacy
